<template>
  <section id="coverage" class="section section-numbers">
    <div class="container">
      <!-- <h1 class="title is-size-1 has-text-centered has-text-white">Our Coverage</h1> -->
      <div class="columns is-centered has-text-centered">
        <div class="column is-half">
          <h1 class="title has-text-white">Our Coverage</h1>
          <p
            class="has-text-white"
          >Clustab currently distributes in Benue and in Abuja. Our team has the functional experience & expertise to profitably grow FMCG businesses.</p>
        </div>
      </div>
      <div class="columns is-vcentered is-5">
        <div class="column">
          <div class="columns">
            <div class="column">
              <div class="metric-card">
                <h3 class="metric-card__count">2</h3>
                <span class="metric-card__title">States</span>
              </div>
            </div>

            <div class="column">
              <div class="metric-card">
                <h3 class="metric-card__count">2</h3>
                <span class="metric-card__title">Manufacturers</span>
              </div>
            </div>

            <div class="column">
              <div class="metric-card">
                <h3 class="metric-card__count">~ 3000</h3>
                <span class="metric-card__title">Stores Covered</span>
              </div>
            </div>

            <!-- <div class="column">
              <div class="metric-card">
                <h3 class="metric-card__count">~ ₦150M</h3>
                <span class="metric-card__title">Monthly Sales</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
	name: 'Metrics'
}
</script>

<style>
.metric-card {
	text-align: center;
}
.metric-card__count {
	color: #fff;
	font-weight: 700;
	font-size: 34px;
}
.metric-card__title {
	color: #fff
}
</style>
